var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.suggestedCoupons.length)?_c('div',_vm._l((_vm.suggestedCoupons),function(coupon){return _c('coupon-item',{key:coupon.code,attrs:{"coupon":coupon}})}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }